import React, { useState } from "react";
import Input from "./Input";
import FormCheck from "./FormCheckbox";
import { Col } from "react-bootstrap";
import DatePicker from "./DatePicker";
import Textarea from "./Textarea";

interface CustomState {
  fieldValueId?: number;
  fieldId: number;
  label: string;
  type: string;
  val?: string | boolean;
  setCustom: any;
  enableSave?: any;
  columns?: number;
  myCase?: boolean;
}

const CustomField = ({ fieldValueId, fieldId, label, type, val, setCustom, enableSave, columns = 4, myCase = true }: CustomState) => {
  const [value, setValue] = useState<string | boolean | null>(val ? val : null);

  const onUpdateValue = (e: any) => {
    const newValue = type === "date" ? e : type === "checkbox" ? !value : e.target.value;
    setValue(newValue);

    setCustom((prev: any[]) => {
      const existingIndex = prev.findIndex((item) => item.fieldId === fieldId);

      if (existingIndex !== -1) {
        // update existing field
        const updated = [...prev];
        updated[existingIndex] = { ...updated[existingIndex], value: newValue };
        return updated;
      } else {
        // add new field
        return [...prev, { fieldValueId, fieldId, value: newValue }];
      }
    });

    if (enableSave) {
      enableSave();
    }
  };

  return (
    <>
      {type === "text" ? (
        <Col xs={columns}>
          <Input
            label={label}
            type="text"
            value={value}
            onUpdate={(e: any) => onUpdateValue(e)}
            css={"mb-3"}
            disabled={myCase ? false : true}
          />
        </Col>
      ) : type === "checkbox" ? (
        <Col xs={columns} className="d-flex align-items-center">
          <FormCheck label={label} value={value} onUpdate={(e: any) => onUpdateValue(e)} css={"mb-3"} disabled={myCase ? false : true} />
        </Col>
      ) : type === "date" ? (
        <Col xs={columns}>
          <div className="mb-3">
            <DatePicker
              label={label}
              currentValue={value}
              setCurrentValue={onUpdateValue}
              hasMaxDate={false}
              disabled={myCase ? false : true}
            />
          </div>
        </Col>
      ) : (
        type === "multi-line text" && (
          <Col xs={columns * 2}>
            <Textarea
              label={label}
              value={value}
              rows={1}
              onUpdate={(e: any) => onUpdateValue(e)}
              css={"mb-3"}
              disabled={myCase ? false : true}
            />
          </Col>
        )
      )}
    </>
  );
};

export default CustomField;
